import React from 'react'

function About() {
  return (
    <div className='footer'>About</div>
  )
}

export default About